module.exports = "/_next/static/images/bo-24408e4f5f84152023ba274bd2b38afa.svg";